// @ts-nocheck
import React from 'react'
import styles from './CardTable.module.scss'
import cx from 'classnames'

export const CardTableCell = ({ children, width = 'auto', className }) => (
  <td
    className={cx(styles.cardTableCell, {
      [className]: Boolean(className),
    })}
    style={{ [`--width`]: width }}
  >
    {children}
  </td>
)
